module.exports = __webpack_public_path__ + "img/frosted.e080b6e7.png";